import { DynamicPage } from 'app/components/DynamicPage'

import * as routePaths from '../routePaths'

export default function Home() {
  return <DynamicPage routePath={routePaths.home()} />
}
